"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Popover = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _usePopoverRect = require("./usePopoverRect");
var _reactDom = require("react-dom");
var _getPrefixCls = require("../../utils/getPrefixCls");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var Popover = function Popover(props) {
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var controlOpenRef = (0, _react.useRef)();
  var controlOpen = (0, _react.useMemo)(function () {
    if (props.open == null) {
      return open;
    }
    return props.open;
  }, [open, props.open]);
  controlOpenRef.current = controlOpen;
  var ref = (0, _react.useRef)(null);
  var position = (0, _usePopoverRect.usePopoverRect)(controlOpen, ref, props.anchorRef);
  (0, _react.useEffect)(function () {
    var _props$anchorRef$curr;
    (_props$anchorRef$curr = props.anchorRef.current) === null || _props$anchorRef$curr === void 0 ? void 0 : _props$anchorRef$curr.addEventListener('click', function () {
      var open = controlOpenRef.current;
      setOpen(!open);
    });
  }, []);
  (0, _react.useEffect)(function () {
    var onClick = function onClick(event) {
      var _props$anchorRef$curr2, _ref$current;
      if (!controlOpenRef.current) {
        return;
      }
      var clickAnchorElement = (_props$anchorRef$curr2 = props.anchorRef.current) === null || _props$anchorRef$curr2 === void 0 ? void 0 : _props$anchorRef$curr2.contains(event.target);
      if (clickAnchorElement) {
        return;
      }
      if (!((_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.contains(event.target)) || props.clickSelfClose) {
        // 如果点击 popover 自己的话也需要关闭，那么立即关闭会导致 popover 内部元素的事件无法触发，
        // 所以在这里停一下，下一个 event loop 再执行
        setTimeout(function () {
          setOpen(false);
        }, 0);
      }
    };
    document.body.addEventListener('click', onClick);
    return function () {
      document.body.removeEventListener('click', onClick);
    };
  }, []);
  return controlOpen ? /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('popover')),
    ref: ref,
    style: _objectSpread({}, position)
  }, props.children), document.body) : null;
};
exports.Popover = Popover;